const experience = [
    {
        role: "Drupal Developer",
        org: "Nationwide IT Services (Federal Client: USGS, FHFA, IRS)",
        years: "November 2022 – April 2026",
        bullets: [
            "Develop and maintained public-facing federal web applications for IRS.gov, FHFA.gov, and USGS using Drupal, PHP, HTML, SCSS, Twig, and JavaScript.",
            "Contributed to the FHFA.gov migration from SharePoint to Drupal, including navigation architecture, page design, content auditing, and migration of 1,000+ pages.",
            "Built custom PHP solutions, performed Drupal module upgrades, resolved production issues, and collaborated with QA and client stakeholders through Agile/Scrum delivery.",
        ],
    },
    {
        role: "Web Developer",
        org: "Nfinity",
        years: "December 2021 – November 2022",
        bullets: [
            "Redesigned and developed public-facing and internal FDIC web pages using HTML, CSS, and JavaScript.",
            "Rebuilt and modernized 1000+ intranet pages for the Division of Resolutions & Receiverships using AEM.",
            "Created and deployed department and bank-termination pages across AuthorWeb and AEM environments.",
        ],
    },
    {
        role: "Backend Developer",
        org: "Beachbody",
        years: "May 2021 – August 2021",
        bullets: [
            "Developed RESTful API endpoints for new parent and child user account services using TypeScript, TypeORM, and AWS Lambda.",
            "Implemented Post, Put, and DELETE functionality through API Gateway event handlers and service-layer architecture.",
            "Wrote unit tests with Jest and mocked service functions to validate API behavior and improve reliability",
        ],
    },
    {
        role: "Full Stack Web Developer, Freelance",
        org: "Allen's Cabinets Kitchen & Bath",
        years: "December 2019 – December 2021",
        bullets: [
            "Designed and developed a full-stack website for a local cabinetry and remodeling business usinc React, and Ruby on Rails",
            "Built RESTful APIs and an authenticated admin portal for creating, editing, and managing project content",
            "Integrated Google Maps, reponsive Bootstrap UI, and email functionality to support customer engagement and business information",
        ],
    },
    {
        role: "Music Educator & Administrator",
        org: "",
        years: "2013 – 2019",
        bullets: [
            "Taught oboe, flute, piano to students of all ages",
            "Handled school administration and student programs",
            "Developed strong communication, organization, and leadership skills",
        ],
    },
]

export default experience
